import axios from "axios"

/**
 * Import DID records via API
 * @param {string} idToken - JWT token for authentication
 * @param {string} apiEndpoint - API endpoint URL
 * @param {Array<Object>} records - Array of DID records to import
 * @returns {Promise<Object>} - Promise resolving to API response
 */
const ImportDocuments = (idToken, apiEndpoint, records) => {
  const headers = {
    headers: {
      "Authorization": idToken,
      "Content-Type": "application/json"
    }
  }

  return new Promise((resolve, reject) => {
    axios.post(apiEndpoint, { records }, headers)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        // Handle different error types
        if (err.response) {
          // Server responded with error status
          const status = err.response.status
          const message = err.response.data?.message || err.response.statusText

          if (status === 401) {
            reject(new Error('Authentication failed. Please log in again.'))
          } else if (status === 403) {
            reject(new Error('Permission denied. Librarian access required.'))
          } else if (status === 400) {
            reject(new Error(`Invalid data: ${message}`))
          } else {
            reject(new Error(`Server error: ${message}`))
          }
        } else if (err.request) {
          // Request made but no response received
          reject(new Error('Network error. Please check your connection and try again.'))
        } else {
          // Something else happened
          reject(new Error(`Import failed: ${err.message}`))
        }
      })
  })
}

export default ImportDocuments
